// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import Scroller from '@newswire/scroller';
import resizer from './ai2html-resizer';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

var scenes = document.querySelectorAll('.scene');

var offset = 0.5;

var scroller = new Scroller({
  container: document.querySelector('.scroller-container'),
  scenes: scenes,
  offset: offset,
});

scroller.init();
